import {fetchJson} from "./utils";
import {Ref, ref} from "vue";

// To store the selected value and avoid that it resets to the Browser default each time
const AUTH2_PREFERRED_LOCALE = 'auth2-preferred-locale'

let selectedLocale :string|null = null
let messages :Ref<Record<string, string>> = ref({})

export async function setLocale(locale :string) :Promise<void> {
    console.log(`Changing language to ${locale}`)
    messages.value = await fetchJson(`./locales/sign-in-${locale}.json`)
    selectedLocale = locale
    // remember it for later
    window.localStorage.setItem(AUTH2_PREFERRED_LOCALE, locale)
}



export function $t(key :string) :string {
    const translated = messages.value[key]
    if(!translated) {
        console.warn('Missing translation for', key)
        return `?${key}?`
    }
    return translated
}


export function getSelectedLocale() :string {
    return selectedLocale ?? localStorage.getItem(AUTH2_PREFERRED_LOCALE) ?? getDefaultLocale()
}


export async function loadMessages() :Promise<void> {
    const locale = getSelectedLocale();
    console.log(`Loading messages for ${locale}`)
    messages.value = await fetchJson(`./locales/sign-in-${locale}.json`)
}



export const DEFAULT_ELO_LOCALE = "en"
export const ELO_LOCALES = [
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "es-419",
    "fi",
    "fr",
    "hu",
    "id",
    "it",
    "nl",
    "pl",
    "pt",
    "pt-BR",
    "ro",
    "sk",
    "sr",
    "sr-Cyrl",
    "tr",
    // EAUTH2-140: Support zh-CN
    "zh-CN"
]

const ADMIN_LOCALES = [
    "de",
    "en",
    "fr"
]

export function getDefaultLocale() :string {
    return pickLocaleFrom(ELO_LOCALES);
}


export function pickLocaleFrom(locales :string[]) :string {
    // in case no locales are specified, pick from all available
    if(!locales)
        locales = ELO_LOCALES

    // EAUTH2-49
    if(locales.length === 1 && ELO_LOCALES.includes(locales[0]))
        return locales[0]

    // contains the browser locales/languages by order of preference
    let langs = navigator.languages
    if(!langs)
        langs = [navigator.language]

    for(const lang of langs) {
        if (locales.includes(lang))
            return lang
        // Fallback to the more generic language (example "pt-BR" -> "pt")
        const shortCode = lang.split("-")[0]
        if (locales.includes(shortCode))
            return shortCode
    }

    return DEFAULT_ELO_LOCALE;
}

// EAUTH2-153: consider selected locale for admin messages
export async function loadAdminMessages() :Promise<void> {
    let locale = getSelectedLocale() // The one chosen during initial sign-in
    if(!ADMIN_LOCALES.includes(locale)) {
        // Note: do not update `selectedLocale`. This is a fallback only for the admin panel messages.
        locale = DEFAULT_ELO_LOCALE;
    }
    messages.value = await fetchJson(`./locales/admin-${locale}.json`)
}

